export default __webpack_public_path__ + "ab0cad03dabd2da7e5f6a1c779c55dea.png";